// extracted by mini-css-extract-plugin
module.exports = {"autosuggest":"autosuggest_autosuggest__JkapG"};